import log from 'loglevel'
import { LocationTrackCompositeLayer } from '@/js/custom-layers/LocationTrackCompositeLayer.js'
import { DataFilterExtension } from '@deck.gl/extensions'

// レイヤーID
const LAYER_ID = 'track'

/**
 * 軌跡のレンダラー
 */
class TrackRenderer {
  /**
   * レイヤーID
   * @returns {String}
   */
  static LAYER_ID() {
    return LAYER_ID
  }

  /**
   * コンストラクタ
   */
  constructor() {}

  /**
   * レンダラー関数を作成する
   * @param {Object|Function} data 描画するデータ
   * @param {Object} props 追加・上書きprops
   * @returns {Object} レンダラー {id: String, render: Function.<LocationTrackCompositeLayer>}
   */
  createRenderer(data, props) {
    log.debug('TrackRenderer create', data, props)
    return {
      id: LAYER_ID,
      render: () => {
        return new LocationTrackCompositeLayer({
          id: LAYER_ID,
          data: typeof data === 'function' ? data() : data,
          groupKey: 'user_id',
          extensions: [new DataFilterExtension({ filterSize: 1 })],
          parameters: {
            blend: true,
            depthRange: [0, 0.89],
          },
          ...props,
        })
      },
    }
  }
}

TrackRenderer.LAYER_ID = LAYER_ID

export default TrackRenderer
